/**
 * Utilitaires pour la gestion des assets (images, icônes, etc.)
 */

/**
 * Récupère l'URL d'une icône personnalisée
 * @param iconFileName - Le nom du fichier de l'icône (ex: "mon-icone.svg")
 * @returns L'URL complète de l'icône
 */
export function getIconUrl(iconFileName: string): string {
  return new URL(`../assets/images/icones/${iconFileName}`, import.meta.url).href
}

/**
 * Récupère l'URL d'une image
 * @param imagePath - Le chemin relatif de l'image depuis le dossier assets/images
 * @returns L'URL complète de l'image
 */
export function getImageUrl(imagePath: string): string {
  return new URL(`../assets/images/${imagePath}`, import.meta.url).href
}

/**
 * Récupère l'URL d'un asset générique
 * @param assetPath - Le chemin relatif de l'asset depuis le dossier assets
 * @returns L'URL complète de l'asset
 */
export function getAssetUrl(assetPath: string): string {
  return new URL(`../assets/${assetPath}`, import.meta.url).href
}
